import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lib-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit {

    isLoading = false;
    get loading(): boolean {
        return this.isLoading;
    }

    @Input() set loading(value: boolean) {
        this.isLoading = value;
    }

    @Input() text?: string;

    constructor() {
    }

    ngOnInit(): void {
    }

}
